/**
 * Format a date string into a readable format
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};